export { DMS_MODULE } from '../constants';
export const NAME = 'WmsAdmin';
export const API_NAME = 'WmsAdmin';
export const CRUMB_LABEL_KEY = 'WmsAdmin';
